import type { ReturnRequestDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { TruckIcon, Warehouse } from "lucide-react";
import ShippingInfo from "@/pages/(app)/returns/view/components/return-sidebar/shipping-info";
import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";

type TransportProps = {
	returnRequest: ReturnRequestDto;
};

export default function Transport({ returnRequest }: TransportProps) {
	const { data: shop } = useCurrentShopSuspense();
	const t = useTranslation();

	return (
		<div>
			{shop.preferences.groupItemsByFulfillment && (
				<WarehouseLocation
					locationId={returnRequest.shipping_info.locationId}
					shop={shop}
				/>
			)}
			<h2 className="text-sm font-medium text-gray-500 inline-flex items-center gap-2">
				<TruckIcon className="size-3" />
				{t("returnDetail.rightBar.transport")}
			</h2>
			{returnRequest.shipping_info.carrier && (
				<ShippingInfo returnRequest={returnRequest} />
			)}
		</div>
	);
}

function WarehouseLocation({
	locationId,
	shop,
}: {
	locationId?: string | null;
	shop: ReturnType<typeof useCurrentShopSuspense>["data"];
}) {
	const t = useTranslation();

	if (!locationId) return null;

	const location = shop.locations?.find((loc) => loc.id === locationId);
	const name = location?.address?.companyName || location?.address?.address1;

	if (!name) return null;

	return (
		<div className="rounded border p-2 my-2 flex flex-col gap-1">
			<span className="inline-flex gap-1 text-xs items-center text-muted-foreground">
				<Warehouse className="size-3" /> {t("returnDetail.warehouse")}
			</span>
			<span className="text-sm font-medium">{name}</span>
		</div>
	);
}
